<template>
  <div class="Home">
    <div class="glide" :bullet="true" >
      <slider  >
        /**
        <slideritem v-for="item in rotationList" :key="item.rotationImgPath" class="glide__slide">
          <div class="backdrop"></div>
          <img v-bind:src="item.rotationImgPath" alt="" />
        </slideritem>
        **/
        <slideritem key="../../resources/images/202303251001025713_.png" class="glide__slide">
          <div class="backdrop"></div>
          <img src="../../resources/images/202303251001025713_.png" alt="" />
        </slideritem>
        <div slot="loading">loading...</div>
      </slider>
    </div>
    <div class="content-wrapper">
      <section class="about-us">
        <h2 class="title2">赋能数字时代，实现价值共赢</h2>
        <p class="intro2">
          众诚科技
        </p>
        <div class="features">
          <div class="feature">
            <p class="feature-content">
              广州众诚科技有限公司总部位于广州，是一家综合性服务解决方案提供商。为全国范围内各行业客户提供涵盖业务外包、解决方案、咨询顾问等全面的综合解决方案专业服务
            </p>
          </div>
          <div class="feature">
            <p class="feature-content">
              公司先后获得微软、K2、甲骨文、华为、UiPath、绿盟、云扩、钉钉等知名厂商的<span>战略合作伙伴、金牌合作伙伴</span>
            </p>
          </div>
          <div class="feature" style="text-align:center;">
            <button v-on:click="aboutUs()" class="feature-buntton">了解我们</button>
          </div>
          
        <div class="feature">
            <p class="feature-content">
              自成立至今，众诚科技凭借在<span>高科技、金融、制造、电信、互联网、汽车、医疗、旅游、交通</span>等行业的深厚积累和丰富经验，和多家世界500强企业建立了长期合作伙伴关系
            </p>
          </div>
        </div>
      </section>
      <section class="showcases section-bg">
        <div class="showcases_features">
          <div class="feature" style="text-align:center;">
            <i class="fas fa-lightbulb"></i>
            <h4 style="padding-top:70px;">企业IT基础架构服务</h4>
            <p class="feature-content" style="padding:10px 10px">
              从IT基础平台管理、企业协同服务、企业信息安全、云服务规划实施为企业提供专项解决方案，帮助企业“从0到1”全方位基础架构平台搭建，助力企业数字化转型进程
            </p>
            <button v-on:click="solution('ITInfrastructure')" class="feature-buntton">了解更多</button>
          </div>
          <div class="feature">
            <i class="fas fa-lightbulb"></i>
            <img style="width:500px;height:300px" src="../../resources/images/1679716401637.png" alt="Logo">
          </div>
          <div class="feature">
            <i class="fas fa-lightbulb"></i>
            <img style="width:500px;height:300px" src="../../resources/images/1679716661117.png" alt="Logo">
          </div>
          <div class="feature" style="text-align:center;">
            <i class="fas fa-lightbulb"></i>
            <h4 style="padding-top:70px">定制化解决方案服务</h4>
            <p class="feature-content" style="padding:10px 10px">
              基于SharePoint协作平台、K2/H3流程管理平台、软件系统架构设计与咨询、移动平台构建及业务平台运维服务
            </p>
            <button v-on:click="solution('customization')" class="feature-buntton">了解更多</button>
          </div>
        </div>
      </section>
      <section class="showcases">
        <div class="showcases_features">
          <div class="feature" style="text-align:center;">
            <i class="fas fa-lightbulb"></i>
            <h4 style="padding-top:70px">智能数据与流程自动化</h4>
            <p class="feature-content" style="padding:10px 10px">
              探索数据解决方案，通过AI高效分析数据，同时通过流程自动化和AI提高工作效率，将资源集中用于创造业务价值，大大降低成本
            </p>
            <button v-on:click="solution('ProcessAutomation')" class="feature-buntton">了解更多</button>
          </div>
          <div class="feature">
            <i class="fas fa-lightbulb"></i>
            <img style="width:500px;height:300px" src="../../resources/images/1679717062889.png" alt="Logo">
          </div>
          <div class="feature">
            <i class="fas fa-lightbulb"></i>
            <img style="width:500px;height:300px" src="../../resources/images/1679717076995.png" alt="Logo">
          </div>
          <div class="feature" style="text-align:center;">
            <i class="fas fa-lightbulb"></i>
            <h4 style="padding-top:70px">ITO资源外包服务</h4>
            <p class="feature-content" style="padding:10px 10px">
              提供专业的人力外包服务，如专业的技术外包服务及年度运维服务
            </p>
            <button v-on:click="solution('ITO')" class="feature-buntton">了解更多</button>
          </div>
        </div>
      </section>
      <section class="team-intro section-bg">
        <h2 class="title1">成功案例</h2>
        <div class="team-members">
          <div class="team-member"  v-on:click="successCases('AzureImplementation')">
            <div class="profile-image">
              <img src="../../resources/images/成功案例1.png" alt="" />
            </div>
            <h4 class="name">Azure项目实施</h4>
            <ul class="social-links">
              <li>
                <a href=""><i class="fab fa-weixin"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-weibo"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-github"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-linkedin"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-member"  v-on:click="successCases('ADDomain')">
            <div class="profile-image">
              <img src="../../resources/images/成功案例2.png" alt="" />
            </div>
            <h4 class="name">AD域部署与升级</h4>
            <ul class="social-links">
              <li>
                <a href=""><i class="fab fa-weixin"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-weibo"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-github"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-linkedin"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-member"  v-on:click="successCases('Office365Deployment')">
            <div class="profile-image">
              <img src="../../resources/images/成功案例3.png" alt="" />
            </div>
            <h4 class="name">Office 365部署与迁移</h4>
            <ul class="social-links">
              <li>
                <a href=""><i class="fab fa-weixin"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-weibo"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-github"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-linkedin"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-member"  v-on:click="successCases('Microsoft365Security')">
            <div class="profile-image">
              <img src="../../resources/images/成功案例4.png" alt="" />
            </div>
            <h4 class="name">Microsoft 365信息安全</h4>
            <ul class="social-links">
              <li>
                <a href=""><i class="fab fa-weixin"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-weibo"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-github"></i></a>
              </li>
              <li>
                <a href=""><i class="fab fa-linkedin"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import baseUrl from '../../utils/baseURL'
import axios from '../../utils/http'
import isotope from 'vueisotope'
import { slider, slideritem } from 'vue-concise-slider'// import slider components

export default {
  components: {
    isotope,
    slider,
    slideritem
  },
  name: 'Home',
  data () {
    return {
      rotationList:[],
    }
  },
  created () {
  },
  methods: {
    getRotationList() {
      this.loading = true
      axios.get('/HomeManager/GetRotationList').then(response => {
        this.rotationList = response.data
        for (let i = 0; i < this.rotationList.length; i++) {
          this.rotationList[i].rotationImgPath = baseUrl + this.rotationList[i].rotationImgPath
        }
      })
    },
    aboutUs() {
      this.$router.push('/about')
    },
    solution(tabName) {
      this.$router.push('/solution#' + tabName)
    },
    successCases(tabName) {
      this.$router.push('/successCases#' + tabName)
    },
  },
  mounted: function() {
    //this.getRotationList()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/index.vue